export enum AccountBookingAdvanceTimeNoticeTypes {
    Hours = 'Hours',
    Days = 'Days',
    None = 'None',
}
